import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators, Form, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

import { LocaService } from '../../../service/loca/loca.service';
import { AbcService } from '../../../service/abc/abc.service';
import { LocaBlockService } from '../../../service/loca-block/loca-block.service';
import { TypeColdService } from '../../../service/type-cold/type-cold.service';
import { TypeStockService } from '../../../service/type-stock/type-stock.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { CaseService } from '../../../service/case/case.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { TypeItemService } from 'app/service/type-item/type-item.service';

@Component({
  selector: 'wa9122',
  templateUrl: 'wa9122.component.html',
  styleUrls: ['wa9122.component.scss']
})
export class Wa9122Component implements OnInit, OnChanges {
  public componentTitle = 'WA9122:ロケマスタ修正';

  public abcs: any;
  public locablocks: any;
  public typecolds: any;
  public typestocks: any;
  public typeitems: any;

  private locaId: number;
  public locaCd: FormControl;
  public locaTx: FormControl;
  public locabarcodeTx: FormControl;
  public srclocaCd: FormControl;
  public typecoldCd: FormControl;
  public typeitemCd: FormControl;
  public typestockCd: FormControl;
  public locablockCd: FormControl;
  public locaabcId: FormControl;
  public arrivepriorityNr: FormControl;
  public shippriorityNr: FormControl;
  public mixuselimitFl: number;
  public notarriveFl: FormControl;
  public notshipFl: FormControl;
  public mixitemFl: FormControl;
  public mixlotFl: FormControl;
  public shelfcaseUsed: FormControl;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @ViewChild('scrollContent')
  scrollContent: ElementRef;
  @Input() isShow = false;
  @Input() inputErrorMsg = '';
  @Output() closeButtonClick = new EventEmitter<boolean>();
  @Output() deleteButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private loca = null;

  private isLocaBarcodeTxClassActive = false;
  private isLocaBarcodeTxClassError = false;
  private isTypestockCdClassActive = false;
  private isTypecoldCdClassActive = false;
  private isTypeItemCdClassActive = false;
  private isLocaBlockCdClassActive = false;
  private isLocaAbcIdClassActive = false;
  private isShippriorityNrClassActive = false;
  private isShippriorityNrClassError = false;
  private isLocaTxClassActive = false;
  private isLocaTxClassError = false;
  private isArrivePriorityNrClassActive = false;
  private isArrivePriorityNrClassError = false;
  private isSrclocaCdClassActive = false;
  private isSrclocaCdClassError = false;

  private isUpdateButtonEnabled = false;
  private isMixitemFlDisabled = false;
  private isMixlotFlDisabled = false;
  private isCaseLocaMixItemError = false;
  private isCaseLocaMixLotError = false;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private locaService: LocaService,
    private abcService: AbcService,
    private locaBlockService: LocaBlockService,
    private typeColdService: TypeColdService,
    private typeItemService: TypeItemService,
    private typeStockService: TypeStockService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private caseService: CaseService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    if (sessionStorage.getItem('baseUrlCompany') !== null) {
      this.working = true;
      // TODO should be execute parallel, but API server don't work properly
      this.typeStockService
        .get()
        .then(outputJson => {
          //console.log(JSON.stringify(outputJson));
          this.typestocks = outputJson.typestocks;
          this.typeColdService
            .get()
            .then(_outputJson => {
              //console.log(JSON.stringify(_outputJson));
              this.typecolds = _outputJson.typecolds;
              this.locaBlockService
                .get()
                .then(__outputJson => {
                  //console.log(JSON.stringify(__outputJson));
                  this.locablocks = __outputJson.locablocks;
                  this.abcService
                    .get()
                    .then(___outputJson => {
                      this.working = false;
                      //console.log(JSON.stringify(___outputJson));
                      this.abcs = ___outputJson.abcs;
                    })
                    .catch(error => {
                      this.working = false;
                      this.errorInfo = this.commonService.getErrorMessage(error);
                    });
                })
                .catch(error => {
                  this.working = false;
                  this.errorInfo = this.commonService.getErrorMessage(error);
                });
            })
            .catch(error => {
              this.working = false;
              this.errorInfo = this.commonService.getErrorMessage(error);
            });
        })
        .catch(error => {
          this.working = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
        this.typeItemService
        .get()
        .then(____outputJson => {
          this.typeitems = ____outputJson.itemcategories;
        })
        .catch(error => {
          this.working = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
  }

  ngOnInit(): void {
    (this.locaCd = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.locaTx.maxLength)
    ])),
      (this.locaTx = new FormControl('', [
        Validators.required,
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.locaTx.maxLength)
      ])),
      (this.locabarcodeTx = new FormControl('', [
        Validators.required,
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.locabarcodeTx.maxLength)
      ])),
      (this.srclocaCd = new FormControl('', [
        Validators.maxLength(validation.srclocaCd.maxLength)
      ])),
      (this.arrivepriorityNr = new FormControl('', [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.arrivepriorityNr.maxNr),
        Validators.min(validation.arrivepriorityNr.minNr)
      ])),
      (this.shippriorityNr = new FormControl('', [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.shippriorityNr.maxNr),
        Validators.min(validation.shippriorityNr.minNr)
      ])),
      (this.typestockCd = new FormControl('', [Validators.required])),
      (this.typecoldCd = new FormControl('', [Validators.required])),
      (this.typeitemCd = new FormControl('')),
      (this.locablockCd = new FormControl('', [Validators.required])),
      (this.locaabcId = new FormControl('', [Validators.required])),
      (this.notarriveFl = new FormControl('', [Validators.required])),
      (this.notshipFl = new FormControl('', [Validators.required])),
      (this.mixitemFl = new FormControl('', [Validators.required])),
      (this.mixlotFl = new FormControl('', [Validators.required])),
      (this.shelfcaseUsed = new FormControl('', []));

  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onSubmit() {
    if (!this.isUpdateButtonEnabled)
      return;

      

    var locaTx = this.locaTx.value.trim();
    var locabarcodeTx = this.locabarcodeTx.value.trim();
    var srclocaCd = this.srclocaCd.value.trim();
    this.isCaseLocaMixItemError = false;
    this.isCaseLocaMixLotError = false;
    let errors = false;
    if (this.locaTx.errors !== null) {
      this.locaTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locabarcodeTx.errors !== null) {
      this.locabarcodeTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.srclocaCd.errors !== null) {
      this.srclocaCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.arrivepriorityNr.errors !== null) {
      this.arrivepriorityNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shippriorityNr.errors !== null) {
      this.shippriorityNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typestockCd.errors !== null) {
      this.typestockCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typecoldCd.errors !== null) {
      this.typecoldCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locablockCd.errors !== null) {
      this.locablockCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locaabcId.errors !== null) {
      this.locaabcId.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (this.loca['shelfcaseId'] > 0) {
      if (this.mixitemFl.value == 1) {
        this.isCaseLocaMixItemError = true;
        this.mixitemFl.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (this.mixlotFl.value == 0) {
        this.isCaseLocaMixLotError = true;
        this.mixitemFl.markAsTouched({ onlySelf: true });
        errors = true;
      }
    }

    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    const upduserId: number = JSON.parse(sessionStorage.getItem('loginResult'))['user']['userId'];
    this.locaService
      .put(
        this.locaId,
        this.locaCd.value,
        locaTx,
        locabarcodeTx,
        '',
        this.typestockCd.value,
        this.typecoldCd.value,
        this.typeitemCd.value,
        this.locablockCd.value,
        this.locaabcId.value,
        this.arrivepriorityNr.value,
        this.shippriorityNr.value,
        this.notarriveFl.value,
        this.notshipFl.value,
        this.mixitemFl.value,
        this.mixlotFl.value,
        this.mixuselimitFl,
        srclocaCd,
        upduserId,
        'wa9121'
      )
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnChanges() {

    if (this.inputErrorMsg != null && this.inputErrorMsg.length > 0) {
      this.errorInfo = this.inputErrorMsg;
      return;
    }
    if (this.isShow) {
      this.inputErrorMsg = "";
      this.errorInfo = "";
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.scrollContent.nativeElement.scrollTop = 0;
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const loca: object = JSON.parse(sessionStorage.getItem('loca'));
    this.loca = loca;

    this.locaId = loca['locaId'];
    this.locaCd.setValue(loca['locaCd']);
    var locaTx = loca['locaTx'];
    var locabarcodeTx = loca['locabarcodeTx'];
    var srclocaCd = loca['memoTx'];
    var typestockCd = loca['typestockCd'];
    var typecoldCd = loca['typecoldCd'];
    let typeitemCd = loca['typeitemCd'];
    var locablockCd = loca['locablockCd'];
    var locaabcId = loca['locaabcId'];
    var arrivepriorityNr = loca['arrivepriorityNr'];
    var shippriorityNr = loca['shippriorityNr'];
    this.mixuselimitFl = loca['mixuselimitFl'];
    var notarriveFl = loca['notarriveFl'];
    var notshipFl = loca['notshipFl'];
    var mixitemFl = loca['mixitemFl'];
    var mixlotFl = loca['mixlotFl'];


    this.locaTx.setValue(locaTx);
    this.locabarcodeTx.setValue(locabarcodeTx);
    this.srclocaCd.setValue(srclocaCd);
    this.arrivepriorityNr.setValue(arrivepriorityNr);
    this.shippriorityNr.setValue(shippriorityNr);
    this.typestockCd.setValue(typestockCd);
    this.typecoldCd.setValue(typecoldCd);
    this.typeitemCd.setValue(typeitemCd);
    this.locablockCd.setValue(locablockCd);
    this.locaabcId.setValue(locaabcId);
    this.notarriveFl.setValue(notarriveFl);
    this.notshipFl.setValue(notshipFl);
    this.mixitemFl.setValue(mixitemFl);
    this.mixlotFl.setValue(mixlotFl);

    this.locaCd.disable();
    this.isLocaBarcodeTxClassActive = false;
    this.isLocaBarcodeTxClassError = false;
    this.isTypestockCdClassActive = false;
    this.isTypecoldCdClassActive = false;
    this.isTypeItemCdClassActive = false;
    this.isLocaBlockCdClassActive = false;
    this.isLocaAbcIdClassActive = false;
    this.isShippriorityNrClassActive = false;
    this.isShippriorityNrClassError = false;
    this.isUpdateButtonEnabled = false;
    this.isMixitemFlDisabled = false;
    this.isMixlotFlDisabled = false;

      //標準ケース設定がある場合
      if (loca['shelfcaseId'] > 0){
        this.shelfcaseUsed.setValue(true);
        //商品混載は不可固定
        if(this.mixitemFl.value == 0){
          this.mixitemFl.disable();
          this.isMixitemFlDisabled = true;
        }
        //ロット混載は不可固定
        if(this.mixlotFl.value == 1){
          this.mixlotFl.disable();
          this.isMixlotFlDisabled = true;
        }
      }else{
        this.shelfcaseUsed.setValue(false);
      }
  }

  cancel() {
    this.errorInfo = '';
    //disableを戻す
    this.mixitemFl.enable();
    this.isMixitemFlDisabled = false;
    this.isCaseLocaMixItemError = false;
    this.mixlotFl.enable();
    this.isMixlotFlDisabled = false;
    this.isCaseLocaMixLotError = false;

    sessionStorage.removeItem('loca');
    this.closeButtonClick.emit(false);
  }

  /** Input, Change event start */
  locabarCodeTxClass() {
    return {
      active: this.isLocaBarcodeTxClassActive,
      error: this.isLocaBarcodeTxClassError
    }
  }
  onLocaBarCodeTxInput(event) {
    this.errorInfo = '';

    this.isLocaBarcodeTxClassActive = event.target.value !== this.loca['locabarcodeTx'];
    this.locabarcodeTx.setValue(event.target.value);
    this.isLocaBarcodeTxClassError = this.locabarcodeTx.invalid;
    this.checkUpdateButtonState();
  }

  onTypestockCdChanged() {
    this.errorInfo = '';

    this.isTypestockCdClassActive = this.typestockCd.value !== this.loca['typestockCd'];
    this.checkUpdateButtonState();
  }

  onTypecodeCdChanged() {
    this.errorInfo = '';

    this.isTypecoldCdClassActive = this.typecoldCd.value !== this.loca['typecoldCd'];
    this.checkUpdateButtonState();
  }

  onTypeItemCdChanged() {
    this.errorInfo = '';

    if (this.typeitemCd.value !== this.loca['typeitemCd'] && this.typeitemCd.value === '') {
      this.isTypeItemCdClassActive = true;
    } else if (this.typeitemCd.value !== this.loca['typeitemCd']) {
      this.isTypeItemCdClassActive = true;
    } else {
      this.isTypeItemCdClassActive = false;
    }
    this.checkUpdateButtonState();
  }

  onLocaBlockCdChanged() {
    this.errorInfo = '';

    this.isLocaBlockCdClassActive = this.locablockCd.value !== this.loca['locablockCd'];
    this.checkUpdateButtonState();
  }

  onLocaABCIdChanged() {
    this.errorInfo = '';

    this.isLocaAbcIdClassActive = Number(this.locaabcId.value) !== Number(this.loca['locaabcId']);
    this.checkUpdateButtonState();
  }

  shippriorityNrClass() {
    return {
      active: this.isShippriorityNrClassActive,
      error: this.isShippriorityNrClassError
    }
  }
  onShippriorityNrInput(event) {
    this.errorInfo = '';

    this.shippriorityNr.setValue(event.target.value);
    this.isShippriorityNrClassError = this.shippriorityNr.invalid;
    this.isShippriorityNrClassActive = (!this.isShippriorityNrClassError) && event.target.value !== this.loca['shippriorityNr'] + '';
    this.checkUpdateButtonState();
  }

  locaTxClass() {
    return {
      active: this.isLocaTxClassActive,
      error: this.isLocaTxClassError
    }
  }
  onLocaTxInput(event) {
    this.errorInfo = '';

    this.isLocaTxClassActive = event.target.value !== this.loca['locaTx'];
    this.locaTx.setValue(event.target.value);
    this.isLocaTxClassError = this.locaTx.invalid;
    this.checkUpdateButtonState();
  }

  srclocaCdClass() {
    return {
      active: this.isSrclocaCdClassActive,
      error: this.isSrclocaCdClassError
    }
  }
  onSrclocaCdInput(event) {
    this.errorInfo = '';

    this.isSrclocaCdClassActive = event.target.value !== this.loca['srclocaCd'];
    this.srclocaCd.setValue(event.target.value);
    this.isSrclocaCdClassError = this.srclocaCd.invalid;
    this.checkUpdateButtonState();
  }

  arrivePriorityNrClass() {
    return {
      active: this.isArrivePriorityNrClassActive,
      error: this.isArrivePriorityNrClassError
    }
  }

  onArrivePriorityNrInput(event) {
    this.errorInfo = '';

    this.arrivepriorityNr.setValue(event.target.value);
    this.isArrivePriorityNrClassError = this.arrivepriorityNr.invalid;
    this.isArrivePriorityNrClassActive = (!this.isArrivePriorityNrClassError) && event.target.value !== this.loca['shippriorityNr'] + '';
    this.checkUpdateButtonState();
  }

  onRadioGroupChange() {
    this.errorInfo = '';

    this.checkUpdateButtonState();
  }

  checkUpdateButtonState() {
    if (
      this.locabarcodeTx.errors == null &&
      this.locaTx.errors == null &&
      this.typestockCd.errors == null &&
      this.typecoldCd.errors == null &&
      this.typeitemCd.errors == null &&
      this.locablockCd.errors == null &&
      this.locaabcId.errors == null &&
      this.shippriorityNr.errors == null &&
      this.arrivepriorityNr.errors == null &&
      this.srclocaCd.errors == null

    ) {
      this.isUpdateButtonEnabled =
        this.isLocaBarcodeTxClassActive ||
        this.isLocaTxClassActive ||
        this.isTypestockCdClassActive ||
        this.isTypecoldCdClassActive ||
        this.isTypeItemCdClassActive ||
        this.isLocaBlockCdClassActive ||
        this.isLocaAbcIdClassActive ||
        this.isShippriorityNrClassActive ||
        this.isArrivePriorityNrClassActive ||
        this.isSrclocaCdClassActive ||
        (this.notarriveFl != this.loca['notarriveFl']) ||
        (this.notshipFl != this.loca['notshipFl']) ||
        (this.mixitemFl != this.loca['mixitemFl']) ||
        (this.mixlotFl != this.loca['mixlotFl']) ||
        (this.mixuselimitFl != this.loca['mixuselimitFl']);
    }
    else {
      this.isUpdateButtonEnabled = false;
    }

  }

  onDeleteButtonClick() {
    this.errorInfo = '';
    this.deleteButtonClick.emit();
  }

  /** End */

}

/** 標準ケースを使用している場合、商品混載可にできない */
export const caseLocaMixitemFlValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  console.log('validater呼ばれましたよん');
  const mixitemFl = control.get('mixitemFl');
  const shelfcaseUsed = control.get('shelfcaseUsed');
  const myForm = control.get('myForm');

  console.log(mixitemFl);
  console.log(shelfcaseUsed);
  console.log(control);

  return { 'validateCaseLocaMixitemFl': { valid: false } };
  //return (shelfcaseUsed.value == 1 && mixitemFl.value == 1) ?  { 'validateCaseLocaMixitemFl': { valid: false } } : null;
};



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9122/wa9122.component.ts